'use client';

import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { RichText } from '@lamesarv-sdk/components';
import { customRemarkComponents } from '@/tools/layout';

import { PropsWithClasses } from '@lamesarv-sdk/types';
import { IComponentFrequentlyAskedQuestions } from '@/types/cms';

interface IFaqItemProps extends PropsWithClasses {
  title: string;
  text: string;
  isOpen?: boolean;
}

const FAQItem = (props: IFaqItemProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(!!props.isOpen);

  return (
    <div className={styles.question}>
      <div className={styles.questionHeader} onClick={() => setIsOpen(!isOpen)}>
        <div className={styles.questionTitle}>{props.title}</div>
        <div className={styles.questionIcon}>{isOpen ? '-' : '+'}</div>
      </div>
      <div className={twMerge(styles.questionText, isOpen ? 'block' : 'hidden')}>
        <RichText
          content={props.text}
          customRemarkComponents={customRemarkComponents}
          className={styles.questionText}
        />
      </div>
    </div>
  );
};

export const FrequentlyAskedQuestions = (props: IComponentFrequentlyAskedQuestions) => {
  return (
    <div className={twMerge(styles.container, props.classes)}>
      <div className={styles.containerHeader}>
        <div className={twMerge(styles.title, props.classes_title)}>{props.title}</div>
        <div className={twMerge(styles.text, props.classes_text)}>{props.text}</div>
      </div>
      <div className={styles.containerQuestions}>
        {props.questions.map((question, index) => (
          <FAQItem key={index} title={question.title} text={question.text} isOpen={question.is_open} />
        ))}
      </div>
    </div>
  );
};

const styles = {
  container:
    'container mx-auto flex flex-col gap-8 font-helvetica lg:gap-4 xl:gap-[200px] p-4 lg:flex-row lg:justify-between lg:p-8',
  containerHeader: 'flex-1 flex flex-col gap-4 lg:min-w-[320px]',
  containerQuestions: 'grow flex flex-col',
  title: 'text-blue-700 text-[24px] md:text-[34px] font-bold',
  text: 'text-blue-700 text-[14px] md:text-[16px]',
  question: 'flex flex-col w-full border-b border-black-100 py-6',
  questionHeader: 'flex flex-row gap-2 items-center justify-between w-full cursor-pointer leading-none',
  questionTitle: 'text-blue-700 text-[14px] md:text-[16px] font-bold',
  questionIcon: 'text-blue-700 text-[16px] font-bold',
  questionText: 'text-[14px] md:text-[16px] pt-4',
};
